export type tJwtTimeClaims = { exp?: number; iat?: number };

// Timing hints only, never signature verification or an authentication decision.
export const readJwtTimeClaims = (token: string): tJwtTimeClaims | undefined => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3 || !parts[1]) return undefined;
    const claims: unknown = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (typeof claims !== 'object' || claims === null || Array.isArray(claims)) return undefined;
    const { exp, iat } = claims as Record<string, unknown>;
    if (exp !== undefined && (typeof exp !== 'number' || !Number.isFinite(exp))) return undefined;
    if (iat !== undefined && (typeof iat !== 'number' || !Number.isFinite(iat))) return undefined;
    if (exp === undefined && iat === undefined) return undefined;
    return { exp: exp as number | undefined, iat: iat as number | undefined };
  } catch {
    return undefined;
  }
};
